import React from 'react';

import TFIActions from 'notebook/tfi/TFIActions';
import {TFIAccount} from 'notebook/tfi/TFIConstants';
import TFIUtil from 'notebook/tfi/TFIUtil';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import SettingsIcon from 'ui-library/icons/SettingsIcon';
import Menu from 'ui-library/menus/Menu';
import {MenuWidth} from 'ui-library/menus/MenuConstants';
import Option from 'ui-library/menus/Option';
import * as modals from 'util/Modals';

interface Props {
  accounts?: Array<TFIAccount> | null;
}

const deleteAccount = (account: TFIAccount): void => {
  modals
    .confirm(
      'Unlink Account',
      <div>
        <p>
          Are you sure you want to unlink your
          {` ${TFIUtil.readableAccountType(account.accountType)} `}
          account <strong>{account.name}</strong>?
        </p>
        <p>
          All files you've imported from the account into Benchling projects will remain there, but you'll
          lose the ability to resync them.
        </p>
      </div>,
      'success',
      {
        acceptText: 'Yes, unlink',
        rejectText: 'No, never mind',
      }
    )
    .done(TFIActions.deleteAccount.bind(null, account.id));
};

export default function TFISettingsIcon({accounts}: Props): JSX.Element | null {
  if (accounts == null || accounts.length === 0) {
    return null;
  }

  return (
    <Dropdown
      menu={
        <Menu width={MenuWidth.FIT_CONTENT}>
          {accounts.map((account, index) => (
            <Option
              key={index}
              onSelect={() => {
                deleteAccount(account);
              }}
            >{`Unlink ${TFIUtil.readableAccountType(account.accountType)}`}</Option>
          ))}
        </Menu>
      }
    >
      <SettingsIcon className="u-small-spacing-left" />
    </Dropdown>
  );
}
